import { Image, View } from "react-native";
import { ImageStyle, ViewStyle } from "react-native";
import { ms } from "@/ui/moderateScale";

export const icons = {
  hamburger: "hamburger.svg",
  cog: "cog.svg",
  caretDown: "caret_down.svg",
  plus: "plus.svg",
  history: "history.svg",
  world: "world.svg",
  send: "send.svg",
  grok: "grok.svg",
  tick: "tick.svg",
  tickCircle: "tick_circle.svg",
  dismiss: "dismiss.svg",
  claude: "claude.svg",
  deepseek: "deepseek.svg",
  openai: "openai.svg",
  qwen: "qwen.png",
  gemini: "gemini.svg",
  document: "document.svg",
  brain: "brain.svg",
  eye: "eye.svg",
  camera: "camera.svg",
  picture: "picture.svg",
  file: "file.svg",
  pen: "pen.svg",
  copy: "copy.svg",
  like: "like.svg",
  unlike: "unlike.svg",
  refresh: "refresh.svg",
  moreHorizontal: "more_horizontal.svg",
  fileAdd: "file_add.svg",
  mic: "mic.svg",
};

export type IconType = keyof typeof icons;

const Icon = ({
  icon,
  style = {},
  containerStyle = {},
}: {
  icon: keyof typeof icons;
  style?: ImageStyle;
  containerStyle?: ViewStyle;
}) => {
  let baseUrl = "/icons";

  return (
    <View style={containerStyle || {}}>
      <div
        style={{
          WebkitTouchCallout: "none",
          WebkitUserSelect: "none",
          KhtmlUserSelect: "none",
          MozUserSelect: "none",
          msUserSelect: "none",
          userSelect: "none",
          touchAction: "manipulation",
        }}
      >
        <Image
          source={{
            uri: `${baseUrl}/${icons[icon]}`,
          }}
          alt={icon}
          style={{ width: ms(24), height: ms(24), ...style }}
        />
      </div>
    </View>
  );
};

export default Icon;
